import layout from './SearchView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';
import Factory from '@/Factories/Factory';
import type SearchViewViewModel from '@/Components/SearchView/SearchViewViewModel';
import { ISummaryViewFactoryConstructorParameter } from '#/CoreFrameInterfaces';
import { SearchViewSearchResult } from '#/DefaultViewExtensionInterfaces';
import AutoGeneratingSummaryViewFactory from '@/Factories/SummaryViewFactories/AutoGeneratingSummaryViewFactory';

export default class SearchView extends View {
    protected view: JQuery<HTMLElement>;
    private currentSummaryViewFactory: AutoGeneratingSummaryViewFactory;

    public constructor(protected viewModel: SearchViewViewModel, protected readonly element?: JQuery<HTMLElement>, private readonly customLayout?: string) {
        super();
        
        this.currentSummaryViewFactory = null;
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, this.customLayout != null ? this.customLayout : layout);
        
        const debouncedRenderSummaryView = _.debounce((x: SearchViewSearchResult) => this.renderSummaryViewAsync(x), 250);
        this.defineSubscription(this.viewModel.selectedSearchResult, sr => debouncedRenderSummaryView(sr));

        return this.view;
    }

    private async renderSummaryViewAsync(searchResult: SearchViewSearchResult) {
        if (this.isDisposed)
            return;
        
        const $summaryViewDiv = this.view.find('div.summaryview');
        $summaryViewDiv.empty();
        
        this.disposeCurrentSummaryView();
        
        if (searchResult == null)
            return;

        await this.viewModel.summaryViewSplitterPane.executeBusilyAsync(async () => {
            if (this.isDisposed)
                return null;

            const factoryParameters: ISummaryViewFactoryConstructorParameter = {
                pdoId: searchResult.pdoId,
                pdTypeName: searchResult.pdTypeName,
                showHistory: true
            };
            this.currentSummaryViewFactory = Factory.createInstance<AutoGeneratingSummaryViewFactory>('AutoGeneratingSummaryView', factoryParameters);

            const $summaryView = await this.currentSummaryViewFactory.getElementAsync();
            $summaryViewDiv.append($summaryView);
        });

    }
    
    private disposeCurrentSummaryView() {
        if (this.currentSummaryViewFactory && !this.currentSummaryViewFactory.isDisposed) {
            this.currentSummaryViewFactory.dispose();
            this.currentSummaryViewFactory = null;
        }
    }
}

ComponentManager.setView('SearchView', SearchView, 'RADPresentation.HTMLClient.DefaultViewExtensions');